module.exports = __webpack_public_path__ + "assets/img/ht_bn.251b5d97.png";